import React, { useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || 'https://uio-poreznik-production.up.railway.app/api';

export default function EntryGate({ onVerified }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    setError(null);
    try {
      const res = await axios.post(`${API_URL}/entry/verify`, { password });
      const token = res.data?.token;
      onVerified?.(token);
    } catch (err) {
      setError(err.response?.data?.error || "Neispravna lozinka");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="entry-gate">
      <div className="entry-card">
        <h2>Zaštita pristupa</h2>
        <p>Unesite pristupnu lozinku za nastavak.</p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Pristupna lozinka"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
          />
          <button type="submit" disabled={loading}>
            {loading ? "Provjera..." : "Pristupi"}
          </button>
        </form>
        {error && <div className="error">{error}</div>}
      </div>
    </div>
  );
}
